import { render, staticRenderFns } from "./manage_files.vue?vue&type=template&id=c66fa26a"
import script from "./manage_files.vue?vue&type=script&lang=js"
export * from "./manage_files.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports